// 可用語言清單靜態設定檔
export const languageList = [
  {
    'value': 'en_US',
    'label': 'English'
  },
  {
    'value': 'zh_CN',
    'label': '简体'
  },
  {
    'value': 'zh_TW',
    'label': '繁體'
  },
  {
    'value': 'vi_VN',
    'label': 'Tiếng Việt'
  },
  {
    'value': 'zh_HK',
    'label': '中文繁体'
    // 香港
  },
  {
    // 荷兰语
    'value': 'af_ZA',
    'label': 'Afrikaans'
  },
  {
    'value': 'ja_JP',
    'label': '日本語'
  },
  {
    'value': 'th_TH',
    'label': 'ไทย'
    // 泰语
  },
  {
    'value': 'my_MY',
    'label': 'Bahasa Melayu'
    // 马来西亚语
  },
  {
    'value': 'da_DK',
    'label': 'Dansk'
    // 丹麦语
  },
  {
    'value': 'de_DE',
    'label': 'Deutsch'
    // 德语
  },
  {
    'value': 'cs_CZ',
    'label': 'Čeština'
    // 捷克语
  },
  {
    'value': 'es_ES',
    'label': 'Español'
    // 西班牙语
  },
  {
    'value': 'tl_PH',
    'label': 'Filipino'
    // 菲律宾语
  },
  {
    'value': 'fr_FR',
    'label': 'Français'
    // 法语
  },
  {
    'value': 'it_IT',
    'label': 'Italiano'
    // 意大利
  },
  {
    'value': 'hu_HU',
    'label': 'Magyar'

    // 匈牙利语
  },
  {
    'value': 'nl_NL',
    'label': 'Nederlands'

    // 荷兰语
  },
  {
    'value': 'no_NO',
    'label': 'Norsk bokmål'
    // 挪威语
  },
  {
    'value': 'pl_PL',
    'label': 'Polski'
    // 波兰语
  },
  {
    'value': 'pt_PT',
    'label': 'Português'
    // 葡萄牙语
  },
  {
    'value': 'fi_FI',
    'label': 'Suomi'
    // 芬兰语
  },
  {
    'value': 'sv_SE',
    'label': 'Svenska'
    // 瑞典
  },
  {
    'value': 'tr_TR',
    'label': 'Türkçe'
    // 土耳其语
  },
  {
    'value': 'ru_RU',
    'label': 'Русский'
    // 俄语
  },
  {
    'value': 'ko_KR',
    'label': '한국어'
    // 韩语
  },
  {
    'value': 'gu_IN',
    'label': 'हिंदी भाषा'
  }
];
